import { SVGProps } from 'react';

const DotsScaleMedium = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M11 7.5C11 8.32843 10.3284 9 9.5 9C8.67157 9 8 8.32843 8 7.5C8 6.67157 8.67157 6 9.5 6C10.3284 6 11 6.67157 11 7.5Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M11 16.5C11 17.3284 10.3284 18 9.5 18C8.67157 18 8 17.3284 8 16.5C8 15.6716 8.67157 15 9.5 15C10.3284 15 11 15.6716 11 16.5Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M16 7.5C16 8.32843 15.3284 9 14.5 9C13.6716 9 13 8.32843 13 7.5C13 6.67157 13.6716 6 14.5 6C15.3284 6 16 6.67157 16 7.5Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M16 12C16 12.8284 15.3284 13.5 14.5 13.5C13.6716 13.5 13 12.8284 13 12C13 11.1716 13.6716 10.5 14.5 10.5C15.3284 10.5 16 11.1716 16 12Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
        <path
            d="M16 16.5C16 17.3284 15.3284 18 14.5 18C13.6716 18 13 17.3284 13 16.5C13 15.6716 13.6716 15 14.5 15C15.3284 15 16 15.6716 16 16.5Z"
            fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
        />
    </svg>
);
export default DotsScaleMedium;
